export default {
  "Login for users": "Se connecter",
  Login: "Email / Téléphone",
  Password: "Mot de passe",
  Submit: "Se connecter",
  "Field required": "Ce champ est obligatoire",
  "Auth error 400": "Identifiant ou mot de passe invalide",
  "Auth error network":
    "Problème de connexion. Veuillez vérifier votre connexion Internet et réessayer.",
  "Auth error unknown": "Erreur inconnue. Veuillez réessayer plus tard.",
  "Login title": "Connexion | «Third Opinion»",
  "Not account yet": "Pas encore de compte ?",
  "Not account yet about":
    "Vous pouvez créer un compte ou essayer le mode démo avec des fonctionnalités limitées.",
  "Demo-mode": "Mode démo",
  "Let register": "Créer un compte",
  "User Agreement Title": "Contrat d'utilisation | «Third Opinion»",
  "User Agreement": "Contrat d'utilisation",
  "Privacy policy": "Politique de confidentialité",
  "User Agreement About part 1": "Pour continuer, vous devez accepter les ",
  "User Agreement About part 2": "le contrat d'utilisation.",
  "User Agree": "J'accepte",
  "Page not found": "Page non trouvée",
  "Page not found about":
    "L'adresse est incorrecte ou la page n'existe plus. Retour à la page principale.",
  "Back to main page": "Retour à la page principale",
  "Login for users 2":
    "Accédez à toutes les fonctionnalités de la plateforme «Third Opinion»",
  Step: "Étape",
  "Min 8": "Au moins 8 caractères",
  "1 char": "1 lettre",
  "1 num": "1 chiffre",
  "Auth access 1": "J'accepte le ",
  "Auth access 2": "traitement des données personnelles",
  "Auth access 3": ", J'accepte ",
  "Auth access 4": "politique de confidentialité",
  "Auth access 5": "et",
  "Auth access 6": "Conditions d'utilisation",
  "Auth access 7": "recevoir du matériel publicitaire et informatif",
  "Have account?": "Vous avez déjà un compte ?",
  "To next": "Suivante",
  "Reg for users 1": "Créer un compte",
  "Reg for users 2": "Parlez-nous de vous",
  "Reg for users 3": "Complétez votre inscription",
  "Your last_name": "Votre nom de famille",
  "Your first_name": "Votre prénom",
  "Your middle_name": "Votre deuxième prénom",
  "Your company": "Votre entreprise",
  "Your position_in_the_company": "Votre poste",
  Back: "Retour",
  "Min 2": "Au moins 2 caractères",
  Promo: "Code promotionnel (si disponible)",
  invitation_1: "De la part d'amis / collègues",
  invitation_2: "Bulletin d'information électronique",
  invitation_3: "Rechercher dans Google",
  invitation_4: "Une autre source",
  invitation_5: "Réseaux sociaux",
  "Where know about platform?":
    "Comment avez-vous découvert notre plateforme ?",
  "Reg finish": "Finaliser l'inscription",
  regErrorText:
    "L'utilisateur n'a pas pu être enregistré. Vérifiez les données.",
  "Auth banner text":
    "Connectez-vous pour accéder à toutes les fonctionnalités de la plateforme",
  "Auth banner text 2":
    "Connectez-vous pour augmenter le nombre d'études à traiter",
  "Auth banner text 3": "Faites traiter vos recherches<br/>gratuitement",
  "Reg error":
    "Malheureusement, l'inscription n'a pas pu être finalisée en raison d'une erreur technique. Veuillez réessayer ultérieurement.",
  "Reg error 400": "L'adresse e-mail est déjà utilisée",
  "Rem password": "Saisissez l'adresse e-mail indiquée lors de l'inscription",
  Phone: "Téléphone",
  "Not valid phone": "Le téléphone est incorrect",
  emailVerify: {
    title: "Confirmation par e-mail",
    desc1: "Un email de confirmation a été envoyé à ",
    desc2:
      ". Veuillez suivre le lien dans la lettre pour activer votre compte et accéder au service.",
  },
};
